module.exports = __webpack_public_path__ + "static/fonts/WebComponentsIcons.c287b98.woff";


//////////////////
// WEBPACK FOOTER
// ./src/shared-components/spreadsheet/kendoui/fonts/glyphs/WebComponentsIcons.woff?gedxeo
// module id = 1631
// module chunks = 28